/**
 * 厅战 邀请
 */

import React from 'react';
import styled from 'styled-components';
import { UiModal } from '@/components';

import StagePartyList from './stage-party-list';
import StageLunchFlight from './stage-lunch-flight';
import StageAcceptFight from './stage-accept-fight';
import StageStarList from './stage-star-list';
import gamesFightStore from '../store';

type Props = {
  stage: 'partyList' | 'starList' | 'lunch' | 'accept';
  item: any;
  isParty?: boolean;
  onClose?: any;
};
const PopupInvite = (props: Props) => {
  const { stage = 'partyList', isParty = false, item = {}, onClose } = props;

  const StageMap = {
    partyList: {
      title: '与厅PK',
      component: StagePartyList,
    },
    starList: {
      title: '与个播PK',
      component: StageStarList,
    },
    lunch: {
      title: isParty ? '与厅PK邀请发送' : '与个播PK邀请发送',
      component: StageLunchFlight,
    },
    accept: {
      title: item.roomType === 6 ? '厅PK发来邀请' : '个播PK发来邀请',
      component: StageAcceptFight,
    },
  };
  const stageInfo = StageMap[stage];
  const StageComponent = stageInfo.component;

  return (
    <Wrap {...props} width={460} title={stageInfo.title} isShowFooter={false}>
      <StageComponent item={item} onClose={onClose} />
    </Wrap>
  );
};

const Wrap = styled(UiModal)`
  ._dark & {
    color: #fff;

    .modal-title,
    .icon-close {
      color: #fff;
    }
  }
  .ui-modal-header {
    border-bottom: 0;
  }
  .ui-modal-body {
    padding: 0;
    box-sizing: border-box;
  }
`;

export default PopupInvite;
